import { SolutionOutlined, ScheduleOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import { TbChartHistogram } from "react-icons/tb";
import { RiBankCardFill } from "react-icons/ri";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import { FaFileMedical } from "react-icons/fa6";
import { GoFileSubmodule } from "react-icons/go";
import { FaFileMedicalAlt } from "react-icons/fa";
import { FaFileExcel } from "react-icons/fa";
import { GoFileDiff } from "react-icons/go";
import { BsBank } from "react-icons/bs";
import { BiDetail } from "react-icons/bi";
import { RiMailForbidLine } from "react-icons/ri";
import { MdOutlineNoEncryptionGmailerrorred } from "react-icons/md";
import { FaFileArrowUp } from "react-icons/fa6";
import { BsFileEarmarkBarGraphFill } from "react-icons/bs";

export const items = [
  {
    key: "sub1",
    label: "Consultas",
    icon: <ScheduleOutlined />,
    children: [
      {
        key: "1",
        icon: <TbChartHistogram />,
        label: (
          <NavLink
            to="/consultarpagos"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Histórico de Pagos
          </NavLink>
        ),
      },
      {
        key: "2",
        icon: <RiBankCardFill />,
        label: (
          <NavLink
            to="/cuentasporcobrar"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Cuentas por Cobrar
          </NavLink>
        ),
      },
      {
        key: "3",
        icon: <FaFileInvoiceDollar />,
        label: (
          <NavLink
            to="/estadocuenta"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Estado de Cuenta
          </NavLink>
        ),
      },
      {
        key: "4",
        icon: <FaFileMedical />,
        label: (
          <NavLink
            to="/misautorizaciones"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Mis Autorizaciones
          </NavLink>
        ),
      },
      {
        key: "5",
        icon: <GoFileSubmodule />,
        label: (
          <NavLink
            to="https://autorizaciones.arsrenacer.com/"
            target="_blank"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Portal Autorización
          </NavLink>
        ),
      },
      {
        key: "6",
        icon: <FaFileMedicalAlt />,
        label: (
          <NavLink
            to="/trackautorizaciones"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Estado Autorizaciones
          </NavLink>
        ),
      },
      {
        key: "7",
        icon: <FaFileExcel />,
        label: (
          <NavLink
            to="/authanuladas"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Autorizaciones Anuladas
          </NavLink>
        ),
      },
      {
        key: "8",
        icon: <GoFileDiff />,
        label: (
          <NavLink
            to="/estadoncf"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Estado NCF
          </NavLink>
        ),
      },
      {
        key: "9",
        icon: <BsBank />,
        label: (
          <NavLink
            to="/cuentasbancarias"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Cuentas Bancarias
          </NavLink>
        ),
      },
      {
        key: "10",
        icon: <BiDetail />,
        label: (
          <NavLink
            to="/detalledepagos"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Detalle De Pagos
          </NavLink>
        ),
      },
    ],
  },
  {
    key: "sub2",
    label: "Solicitudes",
    icon: <SolutionOutlined />,
    children: [
      {
        key: "11",
        icon: <RiMailForbidLine />,
        label: (
          <NavLink
            to="/cartaretencion"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Carta Retención
          </NavLink>
        ),
      },
      {
        key: "12",
        icon: <MdOutlineNoEncryptionGmailerrorred />,
        label: (
          <NavLink
            to="/anularautorizacion"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Anular Autorización
          </NavLink>
        ),
      },
      {
        key: "13",
        icon: <FaFileArrowUp />,
        label: (
          <NavLink
            to="/solicitudpagoportransferencia"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Solicitud Pago Transferencia
          </NavLink>
        ),
      },
      {
        key: "14",
        icon: <BsFileEarmarkBarGraphFill />,
        label: (
          <NavLink
            to="/mistarifas"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Mis Tarifas
          </NavLink>
        ),
      },
    ],
  },
];
